export const tagline = `Clovyr is a company dedicated to building friendly, 
flexible tools that bring the usability of modern applications to decentralized
alternatives. We prioritize privacy, security, and choice, without compromising
convenience and user experience.`;
